import React, { useContext, useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import { useForm as hookUseForm, Controller } from 'react-hook-form';
import { useFetch } from '../../hooks/useFetch';
import { UserContext } from '../../context/UserContext';
import { useAuthToken } from '../../hooks/useAuthToken';
import { Toast, PwdEye } from '../../components/controls/UIControls';
import Modal from '@mui/material/Modal';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FinishedCourses } from './FinishedCoursesTab';
import { landingImages, MINIMUM_CERT_SCORE } from './shared';
import { InProgressCourses } from './InProgressNewCoursesTab';
import { AmountFormat } from '../controls/AmountFormat';
import moment from 'moment';
import { PasswordValidator } from '../controls/PasswordValidator';
import * as CONSTANTS from '../../assets/constants';
import WebChatZoomCrm from '../../assets/zoom-messenger-react/lib/addBubble.js';

// Sección perfil de usuario
export const ProfileSection = () => {
  const params = new URLSearchParams(window.location.search);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors },
  } = hookUseForm({ reValidateMode: 'onChange' });
  const { user, setUser } = useContext(UserContext);
  const [isDisabled, setisDisabled] = useState(true);

  const [showModalEmailNotChange, setShowModalEmailNotChange] = useState(false);
  const [showModalConfirmUpdate, setShowModalConfirmUpdate] = useState(false);
  const setShowModalUpdated = useState(false);
  const [profileMenuSection, setProfileMenuSection] = useState([false, false, false]);

  const [profileError, setProfileError] = useState('');

  const navigate = useNavigate();
  let userNotContext = {};
  const [data, handleFetch] = useFetch();
  const { authToken, setSessionUser, getSavedAuthToken } = useAuthToken();
  const location = useLocation();
  const [toastProperties, setToastProperties] = useState({ show: false });
  const afterCloseToast = () => {
    setToastProperties({ show: false });
  };

  const [showModalChangePassword, setShowModalChangePassword] = useState(false);

  useEffect(() => {
    //This If allows recive a parameter to render a specific section of the profile page
    //If you want to go directly to My courses you should send as a URL parameter 'mis-cursos'
    //If you want to go directly to Payments you should send as a URL parameter 'pagos-y-facturas'
    //If you want to go directly to the information section of the user you shouldn't send anything
    //But by default, if it doesn't recognize the parameter, it will render the information section

    if (params.get('profileSection') === 'mis-cursos') {
      setProfileMenuSection([false, true, false]);
    } else if (params.get('profileSection') === 'pagos-y-facturas') {
      setProfileMenuSection([false, false, true]);
    } else {
      setProfileMenuSection([true, false, false]);
    }
    // Handle para consultar datos del usuario
    let isMounted = true;
    const response = handleFetch({
      url: 'users/info',
      method: 'POST',
      headers: { Authorization: `Bearer ${authToken}` },
    });
    response.then(
      (r) => {
        userNotContext = r;
        if (isMounted) {
          switch (userNotContext.documentType) {
            case 'CC':
              setValue('documentType', 'Cédula de Ciudadanía');
              break;
            case 'CE':
              setValue('documentType', 'Cédula de Extranjería');
              break;
            case 'DIE':
              setValue('documentType', 'Documento de Identidad Extranjera');
              break;
            case 'PA':
              setValue('documentType', 'Pasaporte');
              break;
            case 'TI':
              setValue('documentType', 'Tarjeta de Identidad');
              break;

            default:
              setValue('documentType', 'No identificado');
              break;
          }
          setValue('firstName', userNotContext.name);
          setValue('lastName', userNotContext.lastname);
          setValue('userEmail', userNotContext.email);
          setValue('userDocument', userNotContext.document);
          setValue('phone', '+' + userNotContext.phone);
          setisDisabled(false);
          setUser(userNotContext);
        }
      },
      (error) => {
        if (error.errors) {
          console.log(error);
          console.log(error.errors);
          setProfileError(error.errors[0].message);
        }
      }
    );

    return () => {
      isMounted = false;
    };
  }, []);
  // Función de cambio de correo
  const handleOnClickEmail = (e) => {
    if (e.userEmail.includes('@universidadean.edu.co')) {
      setShowModalEmailNotChange(true);
    }
  };
  // Handle para cerrar modals
  const handleCloseModal = () => {
    setShowModalEmailNotChange(false);
    setShowModalConfirmUpdate(false);
    setShowModalUpdated(false);
    setShowModalChangePassword(false);
  };
  const handleChangePassword = () => {
    setShowModalChangePassword(true);
  };
  // Handle para actualizar perfil
  const updateProfile = (formValues) => {
    if (user.email === formValues.userEmail) {
      const response = handleFetch({
        url: 'users/update',
        method: 'POST',
        data: {
          lastname: formValues.lastName,
          name: formValues.firstName,
          phone: formValues.phone.replace('+', ''),
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });
      response.then(
        (r) => {
          setSessionUser(JSON.stringify(r), getSavedAuthToken() !== null);
          setUser(r);
          setToastProperties({
            show: true,
            type: 'success',
            title: '¡Tus datos se han actualizado correctamente!',
            message:
              'Recuerda actualizar tus datos ya que serán usados para generar tus certificados',
            position: { horizontal: 'left' },
          });
        },
        (error) => {
          console.log(error.errors);
          if (error.errors) {
            setProfileError(error.errors[0].message);
          }
        }
      );
    } else {
      setShowModalConfirmUpdate(true);
    }
  };
  // Función para actualizar datos de usuario incluyendo correo electrónico
  const handleConfirmUpdate = (formValues) => {
    const response = handleFetch({
      url: 'users/update',
      method: 'POST',
      data: {
        email: formValues.userEmail,
        lastname: formValues.lastName,
        name: formValues.firstName,
        phone: formValues.phone.replace('+', ''),
      },
      headers: { Authorization: `Bearer ${authToken}` },
    });
    response.then(
      () => {
        navigate('/verificar-email', {
          state: {
            email: formValues.userEmail,
            lastname: formValues.lastName,
            name: formValues.firstName,
            phone: formValues.phone.replace('+', ''),
            changeEmail: true,
          },
        });
      },
      (error) => {
        if (error.errors) {
          setProfileError(error.errors[0].message);
        }
      }
    );
  };
  useEffect(() => {
    setToastProperties(location.state?.toastProperties || { show: false });
    window.history.replaceState(null, '');
  }, []);
  return (
    <>
      <div id="contWebChatZoomCrm">
        <WebChatZoomCrm
          elementId="contWebChatZoomCrm"
          backgroundColor="#3BAC53"
          color="#FFFFFF"
          socialGatewayUrl="https://socialgateway.verzia.io/modules/zoomWebChat/zoomMessengerLog.php?params=N3hMWEdVWndFVytYQnE4cU4xSm1pMlhRaHVvSXVPRmVuNjQrdGFvS0o4cTZaOSt2eFEyNmhoM1Y3TDk1MWNXZFhUbld3YXlEOUdEUlliTUVvYkFkVGEvMHJlNS9pQVFyTXc1MTVOZGNPRW9LN0VsZFNwdFllRFBCVzhrYm1HZ1YyeXFDVE9TUlZYdTBuUE9TbnVaTHM2RkNJVGErSGNDTTFvek5EeXNuc3dhOTJ6RG1TcXdGSmV2eFMwbEJZSmtuUzA0M2cxQ2c5cEpwV1Y2Z1pGZ3lmZ3JHeVp0cFdxTk5UaWZVSStQMmZYR2gxWXVwV2tUWithQzFxTnIwSzFTZmdtenNva0U5NHlaM3pxY3RJVkFQUnl6d1N4MHJONFplem1EN3o5dGc3VUkrR0U3Z05BekE0V2NKNW9NRjl3dldVMUYyUnRYV05yeFk0Q2dDR1VtTDdRd1FtL1BkVUp5U01obktRN2lSeThuWWJaZmtMTkUrcjgyVFFJMFFCM1NKM1p4ckNOUW5sTy9LYWFWbWhqYTJYQWtXTEVjbXoyNDRFd2s1OXNsTlI2R0VuNmVNdHhEbE1hQVdRTER0Wk5rcnVkU0g3Wk9TNmc3QkJRUlRkTnJDbHA2ZXpvVW5SbkFjMlFFK2xLUmhVUHRPQU83S0xmOWd6elkvZ01XeTdqM1BoaDIwQzFEMk12N2pUZitJNFMwYkdFcWUweHJyeFlNSUwxWkhMUXFxMlpCRUpUZFY3dGpsazdBcEtoRS9OdjlrdnphUDcrTnNWQ0xXQWJRWjBMTXlBQmJuekxleFZDbzBWcDkyUzU2dks5b0NxT3l0Vk4xRk5Majlldytqcy9hbk1nSndTVVBRRXlZQlVuMitsYkNpVGtTaVhRdElaa0VyVDMvc3pNSjRvUUdnUlpOdVV5NWpsOUJJSjhnY0hQbC80Z2s5YjE3akZraHVwZ0EzZitFdFIzSEloTERJM0ozSUlua3RZMTNQdm02ZERVM0ZUdjBsaUVLTjk0SGxEN2Y2KzRjWDNXS2tqakVlWGhlRmdxY1Z0WnNWSVhJVjdTclljV09QaUFQbWxsSE1xWldoUzdlN3BGSWtqb0dJV0l5cmFnNnFqNEtWc3VuRnhmNmhsY1FTa1NINGZNYlJBYkdSU2pZZlpKM3d4S1R3MUZrQkpRbVJyVG00SWFYS1RvVzNmOWNTbHF4WWNXWGRZVmV0QXZ5M3V6d1B5TkdpbXhORXJjTUdoWDRQWmo1Z1RxcWxGTzFNNWt4RWZQakh3QzNNcm9GU0hXcGNldDkwR01CbGhmMHlXQ09pck1oT3o4S1NrVkw1U1dNQUY0aURuampZMHBrdldBN0xHUlNmeSt1M0hNbm1iNXV4REh4bWJ3R1VSWFZFaXhnR0ZwQVV5MWhadFZTV1htelFZYjdzR3Y4VE5OY2svQjNMZjdHY0h0MGFCR2lSdEF1TkhmQ2lSZFBDV2VMczQ3ZXU1N1FzZzA5RmxDd21JV3R1WkE1WWJIclFCamJNKytuNVhNeE1TempUTXEzY1lYY0QxSzBmQ01GZnp5bHhna0lrYVB3Y1BVTW11TU45TUxRLzczYz0="
        />
      </div>
      <div className="ProfilePage__banner-container">
        <div className="ProfilePage__banner-text-container" style={{ position: 'absolute' }}>
          <p className="ProfilePage__banner-text">MI PERFIL</p>
          <p className="ProfilePage__banner-user-name">Hola, {user?.name}</p>
        </div>
        <img
          alt="banner"
          className="d-lg-block d-none"
          src={landingImages('./banner-profile-medium.jpg')}
          width="100%"
        />
        <img
          alt="banner"
          className="d-none d-md-block d-lg-none"
          src={landingImages('./banner-profile.jpg')}
          width="100%"
        />
        <img
          alt="banner"
          className="d-block d-md-none d-lg-none"
          src={landingImages('./banner-profile-small.jpg')}
          width="100%"
        />
      </div>
      <div></div>
      <div className="row justify-content-center my-4">
        <ProfileMenuSection
          profileMenuSection={profileMenuSection}
          setProfileMenuSection={setProfileMenuSection}
          handleFetch={handleFetch}
          authToken={authToken}
        />
        {profileMenuSection[0] ? (
          <div className="ProfilePage__user-info-container">
            <div className="row p-3">
              <form onSubmit={handleSubmit(updateProfile)}>
                <div className="ProfilePage__input-flex">
                  <div className="mb-3">
                    <label className="ProfilePage__form-label">Nombres</label>
                    <input
                      disabled={isDisabled}
                      type="text"
                      name="firstName"
                      className={`form-control ProfilePage__input `}
                      placeholder="Ingrese su nombre"
                      {...register('firstName', { required: 'Es necesario ingresar un nombre' })}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="ProfilePage__form-label">Apellidos</label>
                    <input
                      disabled={isDisabled}
                      type="text"
                      name="lastName"
                      className={`form-control ProfilePage__input `}
                      placeholder="Ingrese su apellido"
                      {...register('lastName', { required: 'Es necesario ingresar un apellido' })}
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label className="ProfilePage__form-label">Correo </label>
                  <input
                    disabled={isDisabled || !user?.canUpdateEmail}
                    type="text"
                    name="userEmail"
                    className={`form-control ProfilePage__input 
                                                    ${errors.userEmail ? 'ProfilePage__input--error' : ''}`}
                    placeholder="nombre@correo.com"
                    {...register('userEmail', {
                      required: 'Es necesario ingresar un correo',
                      onBlur: handleSubmit(handleOnClickEmail),
                      pattern: {
                        value:
                          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        message: 'Debes ingresar un correo válido',
                      },
                    })}
                  />
                  {errors?.userEmail && (
                    <span role="alert" className="ProfilePage__inputError">
                      {errors.userEmail.message}
                    </span>
                  )}
                  {!user?.canUpdateEmail && (
                    <div className="ProfilePage__info-email-no-change">
                      <span>
                        Si deseas cambiar tu correo de comunidad eanista por otro correo, escríbenos
                        a soporteeanx@universidadean.edu.co
                      </span>
                    </div>
                  )}
                </div>
                <div className="ProfilePage__input-flex">
                  <div className="">
                    <label className="ProfilePage__form-label">Tipo de documento</label>
                    <input
                      className={`form-control ProfilePage__input `}
                      disabled={true}
                      name="documentType"
                      placeholder="Tipo de documento"
                      type="text"
                      {...register('documentType', {
                        required: 'Es necesario seleccionar un tipo de documento',
                      })}
                    />
                  </div>
                  <div className="">
                    <label className="ProfilePage__form-label">Número de documento</label>
                    <input
                      disabled={true}
                      className={`form-control ProfilePage__input `}
                      name="userDocument"
                      placeholder="Número de documento"
                      type="text"
                      {...register('userDocument', {
                        required: 'Es necesario ingresar un número de documento',
                        pattern: {
                          value: /^[0-9]+$/,
                          message: 'Escribe solo números (no incluyas puntos, comas o guiones)',
                        },
                      })}
                    />
                  </div>
                </div>
                <label className="mb-3">
                  Si deseas cambiar tu <span className="fst-italic">Tipo de documento</span> o{' '}
                  <span className="fst-italic">Número de documento</span> de identidad debes{' '}
                  <Link to="/contactanos" className="text_primary fw-bold">
                    contactarnos.
                  </Link>
                </label>
                <div className="mb-3">
                  <label className="ProfilePage__form-label">Teléfono</label>
                  <Controller
                    name="phone"
                    control={control}
                    className="ProfilePage__select"
                    rules={{ required: 'Es necesario ingresar un número de contacto' }}
                    render={({ field }) => (
                      <PhoneInput
                        {...field}
                        inputClass={`ProfilePage__input-phone 
                                                    ${errors.phone ? 'ProfilePage__input--error' : ''}`}
                        specialLabel=""
                        inputProps={{
                          name: 'phone',
                          required: true,
                          placeholder: '999 999 999',
                        }}
                        country={'co'}
                        disabled={isDisabled}
                      />
                    )}
                  />
                  {errors.phone && (
                    <span role="alert" className="ProfilePage__inputError">
                      {errors.phone.message}
                    </span>
                  )}
                </div>
                <div className="mb-3">
                  <label className="ProfilePage__form-label">Contraseña</label>
                  <Link to={'#'} onClick={handleChangePassword}>
                    <div className="col-12 ProfilePage__change-password">Cambiar contraseña</div>
                  </Link>
                </div>
                <button type="submit" className={`ProfilePage__btn-form`} disabled={data.loading}>
                  {!data.loading && <span>Actualizar</span>}
                  {data.loading && (
                    <>
                      <span> Procesando... </span>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </>
                  )}
                </button>
                <ErrorMessage className="mb-1 auth__errorMessage--2lines" message={profileError} />
                <Toast
                  {...toastProperties}
                  closeCallback={afterCloseToast}
                  position={{ vertical: 'bottom', horizontal: 'left' }}
                ></Toast>
                <ModalConfirmUpdate
                  handleCloseModal={handleCloseModal}
                  showModalConfirmUpdate={showModalConfirmUpdate}
                  handleConfirmUpdate={handleConfirmUpdate}
                  handleSubmit={handleSubmit}
                />
                <ModalChangePassword
                  handleCloseModal={handleCloseModal}
                  showModalChangePassword={showModalChangePassword}
                  handleConfirmUpdate={handleConfirmUpdate}
                  handleSubmit={handleSubmit}
                  control={control}
                  authToken={authToken}
                  watch={watch}
                  setToastProperties={setToastProperties}
                />
                <ModalWarningEmailNotChange
                  handleCloseModal={handleCloseModal}
                  showModalEmailNotChange={showModalEmailNotChange}
                />
              </form>
            </div>
          </div>
        ) : (
          <></>
        )}
        {profileMenuSection[1] ? (
          <ProfileSectionCoursesManager
            handleFetch={handleFetch}
            data={data}
            authToken={authToken}
            user={user}
          />
        ) : (
          <></>
        )}
        {profileMenuSection[2] ? (
          <ProfileSectionPaymentsAndBills
            handleFetch={handleFetch}
            data={data}
            authToken={authToken}
          />
        ) : (
          <></>
        )}
      </div>
      <div></div>
    </>
  );
};
// Función menú opciones en página de perfil
const ProfileMenuSection = ({ profileMenuSection, setProfileMenuSection }) => {
  const navigate = useNavigate();
  return (
    <div className="ProfilePage__menu-container ProfilePage__margin-50">
      <div className="ProfilePage__menu-margins">
        <div className="row justify-content-center align-items-center">
          <div className="col-11">
            <div
              className={`row ${profileMenuSection[0] ? 'ProfilePage__menu-item-active' : 'ProfilePage__menu-item'} `}
              onClick={() => setProfileMenuSection([true, false, false])}
            >
              <div className="col-1 p-0 ProfilePage__menu-icon">
                <img
                  alt="check icon"
                  src={landingImages('./icons/infocuenta.png')}
                  style={{ maxWidth: '24px', minWidth: '20px', marginTop: '-4px' }}
                />
              </div>
              <div className="col-10  p-0 ProfilePage__menu-text">Información de Cuenta</div>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-11">
            <div
              className={`row ${profileMenuSection[1] ? 'ProfilePage__menu-item-active' : 'ProfilePage__menu-item'} `}
              onClick={() => setProfileMenuSection([false, true, false])}
            >
              <div className="col-1 p-0 ProfilePage__menu-icon">
                <img
                  alt="check icon"
                  src={landingImages('./icons/miscursos.png')}
                  style={{
                    maxWidth: '24px',
                    minWidth: '20px',
                    marginTop: '-4px',
                    marginRight: '5px',
                  }}
                />
              </div>
              <div className="col-10 p-0 ProfilePage__menu-text">Cursos y Certificados</div>
            </div>
          </div>
        </div>
        {/*<div className='row justify-content-center'>
                                <div className='col-11'>
                                    <div className={`row ${profileMenuSection[2]? 'ProfilePage__menu-item-active':'ProfilePage__menu-item'} `} onClick={()=>setProfileMenuSection([false, false, true])}>
                                        <div className='col-1  p-0 ProfilePage__menu-icon'>
                                            <img alt='check icon' src={landingImages('./icons/pagos.png')}  style={{maxWidth: "24px", minWidth: "20px", marginTop: "-4px", marginRight: "5px"}}/>
                                        </div>
                                        <div className='col-10 p-0 ProfilePage__menu-text'>
                                            Pagos y Facturas
                                        </div>
                                    </div>
                                </div>
    </div>*/}
        <div className="row justify-content-center">
          <div className="col-11">
            <div className={'row ProfilePage__menu-item'} onClick={() => navigate('/cursos')}>
              <div className="col-1  p-0 ProfilePage__menu-icon">
                <img
                  alt="check icon"
                  src={landingImages('./icons/catalogo.png')}
                  style={{
                    maxWidth: '24px',
                    minWidth: '20px',
                    marginTop: '-4px',
                    marginRight: '5px',
                  }}
                />
              </div>
              <div className="col-10 p-0 ProfilePage__menu-text">Catálogo de Cursos</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
// Función cursos inscritos
const ProfileSectionCoursesManager = ({ handleFetch, data, authToken, user }) => {
  const [courseManageMenuView, setCourseManageMenuView] = useState([false, false, false]);

  const [myCourses, setMyCourses] = useState([]);

  useEffect(() => {
    const setCourses = (c_courses) => () => {
      const hasToBegin = c_courses.some((c) => c['user_study.progress'] == 0);
      const hasInProgress = c_courses.some(
        (c) =>
          (c['user_study.progress'] > 0 && c['user_study.progress'] < 100) ||
          (c['user_study.progress'] == 100 && c['user_study.avgScore'] < MINIMUM_CERT_SCORE)
      );
      const hasCompleted = c_courses.some(
        (c) => c['user_study.progress'] == 100 && c['user_study.avgScore'] >= MINIMUM_CERT_SCORE
      );
      if (hasToBegin) {
        setCourseManageMenuView([true, false, false]);
      } else if (hasInProgress) {
        setCourseManageMenuView([false, true, false]);
      } else if (hasCompleted) {
        setCourseManageMenuView([false, false, true]);
      } else {
        setCourseManageMenuView([true, false, false]);
      }
      return c_courses;
    };

    const response = handleFetch({
      url: '/courses/taken',
      method: 'GET',
      headers: { Authorization: `Bearer ${authToken}` },
    });
    response.then(
      (r) => {
        setMyCourses(setCourses(r.data));
      },
      (error) => {
        console.log(error.errors);
      }
    );
  }, []);

  return (
    <div className="ProfilePage__courses-manager-container">
      <div className="row">
        <div className="col-12 col-md-10 col-lg-8 col-xl-7">
          <div className="row ProfilePage__courses-manager-menu">
            <div className="col-4" onClick={() => setCourseManageMenuView([true, false, false])}>
              <span className={` ${courseManageMenuView[0] ? 'menu-view-active' : 'menu-view'} `}>
                Por iniciar
              </span>
            </div>
            <div className="col-4" onClick={() => setCourseManageMenuView([false, true, false])}>
              <span className={` ${courseManageMenuView[1] ? 'menu-view-active' : 'menu-view'} `}>
                En progreso
              </span>
            </div>
            <div className="col-4" onClick={() => setCourseManageMenuView([false, false, true])}>
              <span className={` ${courseManageMenuView[2] ? 'menu-view-active' : 'menu-view'} `}>
                Certificados
              </span>
            </div>
          </div>
        </div>
      </div>
      {data.loading ? (
        <>
          <Loading />
        </>
      ) : (
        <>
          {courseManageMenuView[0] ? (
            <InProgressCourses myCourses={myCourses} newCoursesOnly={true} />
          ) : (
            <></>
          )}
          {courseManageMenuView[1] ? <InProgressCourses myCourses={myCourses} /> : <></>}
          {courseManageMenuView[2] ? <FinishedCourses myCourses={myCourses} user={user} /> : <></>}
        </>
      )}
    </div>
  );
};
// Menú pagos y planes contratados
const ProfileSectionPaymentsAndBills = ({ data }) => {
  const [paymentsAndBillsMenuView, setPaymentsAndBillsMenuView] = useState([true, false, false]);
  return (
    <div className="ProfilePage__courses-manager-container">
      <div className="row">
        <div className="col-12 col-md-10 col-lg-8 col-xl-7">
          <div className="row ProfilePage__courses-manager-menu">
            <div
              className="col-4"
              onClick={() => setPaymentsAndBillsMenuView([true, false, false])}
            >
              <span
                className={` ${paymentsAndBillsMenuView[0] ? 'menu-view-active' : 'menu-view'} `}
              >
                Plan actual
              </span>
            </div>
            <div
              className="col-8"
              onClick={() => setPaymentsAndBillsMenuView([false, true, false])}
            >
              <span
                className={` ${paymentsAndBillsMenuView[1] ? 'menu-view-active' : 'menu-view'} `}
              >
                Histórico de pagos
              </span>
            </div>
          </div>
        </div>
      </div>
      {data.loading ? (
        <>
          <Loading />
        </>
      ) : (
        <>
          {paymentsAndBillsMenuView[0] ? <PaymentsAndBillsData all={false} /> : <></>}
          {paymentsAndBillsMenuView[1] ? <PaymentsAndBillsData all={true} /> : <></>}
        </>
      )}
    </div>
  );
};
// Función pagos y planes contratados
const PaymentsAndBillsData = ({ all = false }) => {
  const [history, setHistory] = useState([]);
  const { authToken } = useAuthToken();
  const [, handleFetch] = useFetch();
  // useEffect para consultar pagos realizados por el usuario
  useEffect(() => {
    const response = handleFetch({
      url: `payments`,
      method: 'GET',
      headers: { Authorization: `Bearer ${authToken}` },
    });
    response.then(
      (r) => {
        setHistory(r);
      },
      (error) => {
        console.log(error.errors);
      }
    );
  }, []);
  let today = new Date();
  // handle para consultar estado de los planes
  const getPlanStatus = (dateStart, dateEnd) => {
    let status;
    if (new Date(dateEnd).getTime() >= today && new Date(dateStart).getTime() <= today) {
      status = CONSTANTS.PLAN_STATUS_ACTIVE;
    } else if (new Date(dateStart).getTime() > today) {
      status = CONSTANTS.PLAN_STATUS_PENDING;
    } else if (new Date(dateEnd).getTime() <= today && new Date(dateStart).getTime() <= today) {
      status = CONSTANTS.PLAN_STATUS_EXPIRED;
    }
    return status;
  };
  // Función para mostrar estado de cada plan contratado
  const statusCalcule = (dateStart, dateEnd) => {
    const statusCode = getPlanStatus(dateStart, dateEnd);
    let status = '';
    switch (statusCode) {
      case CONSTANTS.PLAN_STATUS_ACTIVE:
        status = <li className="ProfilePage__data-payments-active">Activo</li>;
        break;
      case CONSTANTS.PLAN_STATUS_PENDING:
        status = <li className="ProfilePage__data-payments-pending">Pendiente</li>;
        break;
      case CONSTANTS.PLAN_STATUS_EXPIRED:
        status = <li className="ProfilePage__data-payments-inactive">Vencido</li>;
        break;
    }
    return status;
  };
  // Función para ordenar planes según fecha de contratación
  function SortArray(p1, p2) {
    const statusP1 = getPlanStatus(p1.startsAt, p1.endsAt);
    const statusP2 = getPlanStatus(p2.startsAt, p2.endsAt);
    if (statusP1 != statusP2) return statusP1 - statusP2;
    return new Date(p1.startsAt) - new Date(p2.startsAt);
  }
  var historytest = history.sort(SortArray);
  return (
    <>
      {history.length !== 0 ? (
        all ? (
          historytest.map((data, index) => {
            let statusView = statusCalcule(data?.startsAt, data?.endsAt);
            let payment = moment.utc(data?.createdAt).format('DD/MM/YYYY');
            let dateInit = moment.utc(data?.startsAt).format('DD/MM/YYYY');
            let dateEnd = moment.utc(data?.endsAt).format('DD/MM/YYYY');
            let prefixInit =
              new Date(data?.startsAt).getTime() < new Date().getTime() ? 'Inició' : 'Inicia';
            let prefixEnd =
              new Date(data?.endsAt).getTime() > new Date().getTime() ? 'Vence' : 'Venció';
            return (
              <div className="row" key={index}>
                <div className="col-12 justify-content-center ProfilePage__content-data-payments">
                  <div className="col-11 ProfilePage__data-payments mb-3">
                    <div className="col-12 col-sm-12 col-lg-8 ProfilePage__data-payments-flex">
                      <div className="ProfilePage__data-payments-left fw-bold">
                        {data?.plan['title']}
                      </div>
                      <div className="ProfilePage__data-payments-right ProfilePage__data-payments-status">
                        {statusView}
                      </div>
                      <div className="ProfilePage__data-payments-left">Comprado el {payment}</div>
                      <div className="ProfilePage__data-payments-right">
                        Costo{' '}
                        <AmountFormat
                          name="paidPrice"
                          value={data?.paidPrice}
                          displayType="text"
                          currency="COP"
                        />
                      </div>
                      <div className="ProfilePage__data-payments-left mt-1">
                        {prefixInit} el {dateInit}
                      </div>
                      <div className="ProfilePage__data-payments-right mt-1">
                        {prefixEnd} el {dateEnd}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          history.map((data) => {
            let statusView = statusCalcule(data?.startsAt, data?.endsAt);
            let payment = moment.utc(data?.createdAt).format('DD/MM/YYYY');
            let dateInit = moment.utc(data?.startsAt).format('DD/MM/YYYY');
            let dateEnd = moment.utc(data?.endsAt).format('DD/MM/YYYY');
            return (
              new Date(data?.endsAt).getTime() >= today &&
              new Date(data?.startsAt).getTime() <= today && (
                <>
                  <div className="row">
                    <div className="col-12 justify-content-center ProfilePage__content-data-payments">
                      <div className="col-11 ProfilePage__data-payments mb-3">
                        <div className="col-12 col-sm-12 col-lg-8 ProfilePage__data-payments-flex">
                          <div className="ProfilePage__data-payments-left fw-bold">
                            {data?.plan['title']}
                          </div>
                          <div className="ProfilePage__data-payments-right ProfilePage__data-payments-status">
                            {statusView}
                          </div>
                          <div className="ProfilePage__data-payments-left">
                            Comprado el {payment}
                          </div>
                          <div className="ProfilePage__data-payments-right">
                            Costo{' '}
                            <AmountFormat
                              name="paidPrice"
                              value={data?.paidPrice}
                              displayType="text"
                              currency="COP"
                            />
                          </div>
                          <div className="ProfilePage__data-payments-left mt-1">
                            Inicia el {dateInit}
                          </div>
                          <div className="ProfilePage__data-payments-right mt-1">
                            Vence el {dateEnd}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {!data?.canCertificate && (
                    <div className="row">
                      <div className="col-12 justify-content-center ProfilePage__alert-no-certifications">
                        <div className="col-11 ProfilePage__data-alert-no-certifications mb-3">
                          <i className="fa-solid fa-triangle-exclamation"></i> Este tipo de plan no
                          incluye certificaciones.
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )
            );
          })
        )
      ) : (
        <div className="row">
          <div className="col-12 justify-content-center ProfilePage__content-data-payments">
            <div className="col-11 text-center ProfilePage__data-payments mb-3">
              <strong>No existen registros</strong>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Función para mostrar mensaje de error
const ErrorMessage = (props) => {
  return (
    <div className={`auth__errorMessage ProfilePage__info-error ${props.className}`}>
      <span role="alert" dangerouslySetInnerHTML={{ __html: props.message }}></span>
    </div>
  );
};
// Función para mostrar modal con advertencia de actualización de datos
const ModalConfirmUpdate = ({
  showModalConfirmUpdate,
  handleCloseModal,
  handleConfirmUpdate,
  handleSubmit,
}) => {
  return (
    <Modal
      open={showModalConfirmUpdate}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="ProfilePage__modal-base ProfilePage__outline-none">
        <div className="row justify-content-center align-items-center">
          <div className="col-4 text-center">
            <img
              src={landingImages('./icons/lock-icon.svg')}
              style={{ width: '58px', marginTop: '47px' }}
              alt="padlock"
            />
          </div>
          <div className="ProfilePage__modal-info-container">
            <div className="ProfilePage__modal-title">Advertencia</div>
            <p className="ProfilePage__modal-text-description">
              Al hacer este cambio, serás redirigido para que ingreses una validación.<br></br>
              ¿Quieres continuar?
            </p>
            <div className="" style={{ marginTop: '20px', textAlign: 'center' }}>
              <button
                className="ProfilePage__modal-button-accept"
                onClick={handleSubmit(handleConfirmUpdate)}
              >
                Aceptar
              </button>
            </div>
            <div style={{ marginTop: '10px', marginBottom: '40px', textAlign: 'center' }}>
              <button className="ProfilePage__modal-button-cancel" onClick={handleCloseModal}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
// Función para mostrar Modal que permite cambio de contraseña
const ModalChangePassword = ({
  showModalChangePassword,
  handleCloseModal,
  handleSubmit,
  authToken,
  control,
  watch,
  setToastProperties,
}) => {
  const [data, handleFetch] = useFetch();

  const [changePasswordError, setChangePasswordError] = useState('');
  const [confirmPasswordMatches, setConfirmPasswordMatches] = useState(false);
  const [passwordIsValid, setPasswordIsValid] = useState(false);

  const setValidPassword = (isValid) => {
    setPasswordIsValid(isValid);
  };

  const password = watch('password', '');
  const password2 = watch('password2', '');

  useEffect(() => {
    setConfirmPasswordMatches(password === password2);
  }, [password, password2]);
  // Handle para cambio de contraseña
  const handleChangePassword = (e) => {
    setChangePasswordError('');
    if (passwordIsValid && confirmPasswordMatches) {
      const response = handleFetch({
        url: 'users/update',
        method: 'POST',
        data: {
          email: e.userEmail,
          lastname: e.lastName,
          name: e.firstName,
          phone: e.phone.replace('+', ''),
          password: e.password,
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });
      response.then(
        () => {
          setToastProperties({
            show: true,
            type: 'success',
            title: '¡Tu contraseña fue cambiada correctamente!',
            message: 'Recuerda mantenerla en secreto por medidas de seguridad',
            position: { horizontal: 'left' },
          });
          handleCloseModal();
        },
        (error) => {
          if (error.errors) {
            setChangePasswordError(error.errors[0].message);
          }
        }
      );
    }
  };
  const handleCloseModalAux = () => {
    handleCloseModal();
  };
  return (
    <Modal
      open={showModalChangePassword}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="ProfilePage__modal-base ProfilePage__outline-none">
        <div className="row justify-content-center align-items-center">
          <div className="ProfilePage__modal-info-container">
            <form onSubmit={handleSubmit((e) => handleChangePassword(e))}>
              <div className="mt-3">
                <label className="auth__form-label">
                  Nueva contraseña <span className="auth__required-input">*</span>
                </label>
                <Controller
                  name="password"
                  control={control}
                  rules={{ required: CONSTANTS.MESSAGE_PASSWORD_REQUIRED }}
                  render={({ field: { onChange, onBlur, name }, fieldState: { invalid } }) => {
                    return (
                      <PwdEye
                        className={`form-control auth__input ${invalid ? 'auth__input--error' : ''}`}
                        placeholder={CONSTANTS.LABEL_PASSWORD_PLACEHOLDER}
                        onChange={onChange}
                        onBlur={onBlur}
                        name={name}
                        error={invalid}
                      ></PwdEye>
                    );
                  }}
                />
                <div className="ProfilePage__conditions-password">
                  <PasswordValidator
                    value={password}
                    checkCriteria={setValidPassword}
                  ></PasswordValidator>
                  <div className={`${passwordIsValid ? 'd-none' : ''}`}>
                    <ErrorMessage
                      message={!passwordIsValid ? CONSTANTS.MESSAGE_PASSWORD_IVALID : ''}
                    ></ErrorMessage>
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <label className="auth__form-label">
                  Repite tu contraseña <span className="auth__required-input">*</span>
                </label>
                <Controller
                  name="password2"
                  control={control}
                  rules={{ required: CONSTANTS.MESSAGE_PASSWORD_REQUIRED }}
                  render={({ field: { onChange, onBlur, name }, fieldState: { invalid } }) => {
                    return (
                      <PwdEye
                        className={`form-control auth__input ${invalid ? 'auth__input--error' : ''}`}
                        placeholder={CONSTANTS.LABEL_PASSWORD_CONFIRM_PLACEHOLDER}
                        onChange={onChange}
                        onBlur={onBlur}
                        name={name}
                        error={invalid}
                      ></PwdEye>
                    );
                  }}
                />
                <div className={`${confirmPasswordMatches ? 'd-none' : ''}`}>
                  <ErrorMessage
                    message={
                      !confirmPasswordMatches ? CONSTANTS.MESSAGE_PASSWORD_CONFIRM_DOESNT_MATCH : ''
                    }
                  ></ErrorMessage>
                </div>
              </div>
              <div className={`${!changePasswordError ? 'd-none' : ''}`}>
                <ErrorMessage
                  className="mb-1 text-center auth__errorMessage--2lines"
                  message={changePasswordError}
                />
              </div>
              <div className="" style={{ textAlign: 'center' }}>
                <button
                  className="ProfilePage__modal-button-accept"
                  onClick={handleSubmit(handleChangePassword)}
                >
                  {!data.loading && <span>Cambiar contraseña</span>}
                  {data.loading && (
                    <>
                      <span> Procesando... </span>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </>
                  )}
                </button>
              </div>
              <div style={{ marginTop: '10px', marginBottom: '40px', textAlign: 'center' }}>
                <button className="ProfilePage__modal-button-cancel" onClick={handleCloseModalAux}>
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Modal>
  );
};
// Función para mostrar modal en caso cambio de correo electrónico de comunidad eanista
const ModalWarningEmailNotChange = ({ showModalEmailNotChange, handleCloseModal }) => {
  return (
    <Modal
      open={showModalEmailNotChange}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="ProfilePage__modal-base ProfilePage__outline-none">
        <div className="row justify-content-center align-items-center">
          <div className="col-4 text-center">
            <img
              src={landingImages('./icons/lock-icon.svg')}
              style={{ width: '58px', marginTop: '47px' }}
              alt="padlock"
            />
          </div>
          <div className="ProfilePage__modal-info-container">
            <div className="ProfilePage__modal-title">Advertencia</div>
            <p className="ProfilePage__modal-text-description">
              Recuerda que si eliges cambiar tu correo por uno de{' '}
              <span className="ProfilePage__color-green fw-bold">comunidad eanista</span>, este
              cambio sólo será reversible comunicándote con nuestro{' '}
              <span className="ProfilePage__color-green fw-bold">equipo de soporte</span>
            </p>
            <div style={{ marginTop: '10px', textAlign: 'center' }}>
              <button
                className="ProfilePage__modal-button-accept"
                onClick={handleCloseModal}
                style={{ marginLeft: '0px' }}
              >
                Aceptar
              </button>
            </div>
            <div style={{ marginTop: '10px', marginBottom: '40px', textAlign: 'center' }}>
              <button className="ProfilePage__modal-button-cancel" onClick={handleCloseModal}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

/**
 * Creado por Equilibrio Agency 2022<br>
 * Función Loading
 * @function Loading
 */
const Loading = () => {
  const loadingImage = landingImages('./icons/loading_spin_ean.svg');
  return (
    <div className="d-flex justify-content-center" style={{ minHeight: '300px' }}>
      <div className="row text-center position-absolute justify-content-center">
        <img alt="Loader" src={loadingImage} />
      </div>
    </div>
  );
};
